module.exports = __webpack_public_path__ + "img/smile-icon.69c66a47.svg";